import { CanActivateFn, Router } from '@angular/router';
import { AuthorizationService } from '../../services/authorization/authorization.service';
import { inject } from '@angular/core';
import { UserService } from '../../services/authorization/user.service';

export const noAuthorizationGuard: CanActivateFn = () => {
  const userService: UserService = inject(UserService);
  const authorizationService: AuthorizationService =
    inject(AuthorizationService);
  const router: Router = inject(Router);

  if (authorizationService.isLoggedIn && userService.user?.domain) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
